import React from 'react'

const env = process.env.REACT_APP_ENV

export const StagingBadge = () => {
  if (!env || env === 'production') {
    return null
  }
  return (
    <span style={{ color: '#d97706', fontSize: '0.65rem', letterSpacing: '0.12em', border: '1px solid #d97706', borderRadius: 3, padding: '2px 6px', marginRight: 8, background: 'rgba(217, 119, 6, 0.08)' }}>
      {env.toUpperCase()}
    </span>
  )
}
